import React from 'react'
import ClassNames from 'classnames'

const Slider = (props) => {
	const {
		slides,
		wrap,
	} = props

	const sliderClassNames = ClassNames({
		'slider': true,
		'slider--wrap': wrap,
	})

	return (
		<div className={sliderClassNames}>
			<div className="slider__slides">
				{slides}
			</div>
		</div>
	)
}

Slider.defaultProps = {
	wrap: false,
}

export default Slider



// WEBPACK FOOTER //
// ./src/mobile/components/slider/index.js